<template>
    <div class="d-sm-flex align-items-center justify-content-between mb-2">
        <div>
            <ol class="breadcrumb fs-sm mb-1">
                <li class="breadcrumb-item active">
                    <router-link to="/dashboard">Dashboard</router-link>
                </li>
            </ol>
            <h4 class="main-title mb-2">Dashboard</h4>
        </div>
        <!-- <div class="d-flex align-items-center gap-2 mt-3 mt-md-0">
            <button type="button" class="btn btn-primary d-flex align-items-center gap-2" @click="addPermissions()">
                <i class="ri-bar-chart-2-line fs-18 lh-1"></i> Add Permissions
            </button>
        </div> -->
    </div>
    <div class="row g-3">
        <div class="col-12">
            <!-- <div class="card card-one"> -->
                <div class="card-header">
                    <!-- <h6 class="card-title">Dashboard</h6> -->
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <div class="col-sm-3" v-can="'users.view'">
                            <router-link to="/users">
                                <div class="task-category p-3 bg-primary">
                                    <h2 class="category-percent mb-2 text-center">{{ total_users }}</h2>
                                    <div class="text-center px-3">
                                        <span><h5 class="text-white">Total Users</h5></span>
                                    </div>
                                </div>
                            </router-link>
                        </div>
                        <div class="col-sm-3" v-can="'trips.view'">
                            <a href ="javascript:void(0)" @click="showTrips()">
                                <div class="task-category p-3" style="background-color: coral;">
                                    <h2 class="category-percent mb-2 text-center">{{ total_trips }}</h2>
                                    <div class="text-center px-3">
                                        <span><h5 class="text-white">Total Trips</h5></span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-3" v-can="'trips.view'">
                            <a href ="javascript:void(0)" @click="showTrips(1)">
                                <div class="task-category p-3 bg-success">
                                    <h2 class="category-percent mb-2 text-center">{{ trips_completed }}</h2>
                                    <div class="text-center px-3">
                                        <span><h5 class="text-white">Trips Completed</h5></span>
                                    </div>
                                </div>
                            </a>
                        </div>
                        <div class="col-sm-3" v-can="'trips.view'">
                            <a href ="javascript:void(0)" @click="showTrips(0)">
                                <div class="task-category p-3 bg-warning">
                                    <h2 class="category-percent mb-2 text-center">{{ trips_pending }}</h2>
                                    <div class="text-center px-3">
                                        <span><h5 class="text-white">Trips Pending</h5></span>
                                    </div>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div class="row" v-can="'trips.view'">
                        <div class="col-sm-12">
                            <div class="card card-one">
                                <div class="card-header">
                                    <h6 class="card-title">Active Trips</h6>
                                    <nav class="nav ms-auto"></nav>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="table-responsive table-responsive-sm">
                                            <table class="table table-bordered table-striped table-sm">
                                                <thead>
                                                    <tr style="background-color: #9b9b9b; color: white;">
                                                        <th class="text-center">#</th>
                                                        <th @click="sort('trip_no')">
                                                            Trip No
                                                            <span>
                                                                <i v-if="meta.keyword == 'trip_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'trip_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th>
                                                        <th class="text-wrap" style="min-width: 6rem; max-width: 8rem;" @click="sort('trip_start_date_time')">
                                                            Trip Start Date & Time
                                                            <span>
                                                                <i v-if="meta.keyword == 'trip_start_date_time' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'trip_start_date_time' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th>
                                                        <th @click="sort('customer_id')">
                                                            Customer
                                                            <span>
                                                                <i v-if="meta.keyword == 'customer_id' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'customer_id' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th>
                                                        <!-- <th @click="sort('transporter_id')">
                                                            Transporter
                                                            <span>
                                                                <i v-if="meta.keyword == 'transporter_id' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'transporter_id' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th>
                                                        <th @click="sort('wagon_no')">
                                                            Wagon No
                                                            <span>
                                                                <i v-if="meta.keyword == 'wagon_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'wagon_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th> -->
                                                        <th>Grade</th>
                                                        <th>Lot No</th>
                                                        <th>Packing</th>
                                                        <th>Loaded Bags</th>
                                                        <th>Loaded Quantity</th>
                                                        <th @click="sort('container_no')">
                                                            Container No
                                                            <span>
                                                                <i v-if="meta.keyword == 'container_no' && meta.order_by == 'asc'" class="ri-arrow-up-line"></i>
                                                                <i v-else-if="meta.keyword == 'container_no' && meta.order_by == 'desc'" class="ri-arrow-down-line"></i>
                                                                <i v-else class="fas fa-sort"></i>
                                                            </span>
                                                        </th>
                                                        <th class="text-center">Actions</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="trips.length==0">
                                                        <td colspan="7" class="text-center">No records found</td>
                                                    </tr>
                                                    <tr v-for="trip, key in trips" :key="key">
                                                        <td class="text-center">{{ meta.from + key }}</td>
                                                        <td>{{ trip.trip_no}}</td>
                                                        <td class="text-wrap" style="min-width: 6rem; max-width: 8rem;">{{ convertDateFormat(trip.trip_start_date_time) }}</td>
                                                        <td>{{ trip.customer?.customer_name }}</td>
                                                        <!-- <td>{{ trip.transporter?.transporter_name }}</td>
                                                        <td>{{ trip.wagon_no }}</td> -->
                                                        <td>{{ trip.details?.grade }}</td>
                                                        <td>{{ trip.details?.lot_nos }}</td>
                                                        <td>{{ trip.details?.packings }}</td>
                                                        <td>{{ trip.details?.loading_bags }}</td>
                                                        <td>{{ trip.details?.loading_quantity }}</td>
                                                        <td>{{ trip.container_no }}</td>
                                                        <td class="text-center">
                                                            <nav>
                                                                <a href="javascript:void(0)" class="text-success me-2" @click.prevent="edit(trip)" :disabled="!trip.status"><i class="ri-pencil-line fs-18 lh-1"></i></a>
                                                                <a href="javascript:void(0)" class="text-success me-2" @click.prevent="view(trip)"><i class="ri-eye-line fs-18 lh-1"></i></a>
                                                            </nav>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <select class="form-select from-select-sm width-75" v-model="meta.per_page" @change="onPerPageChange">
                                            <option>10</option>
                                            <option>15</option>
                                            <option>20</option>
                                            <option>25</option>
                                            <option>30</option>
                                        </select>
                                        <span>Showing {{ meta.from }} to {{ meta.to }} of {{ meta.totalRows }} entries</span>
                                        <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <!-- </div> -->
        </div>
    </div>
</template>
<script>
    import Pagination from "@/components/Pagination.vue";
    import moment from "moment";
    export default {
        components: {
            Pagination,
        },
        data() {
            return {
                total_users: "",
                total_trips: "",
                trips_completed: "",
                trips_pending: "",
                trips: [],
                meta: {
                    search: "",
                    order_by: "desc",
                    keyword: "trip_id",
                    per_page: 10,
                    totalRows: 0,
                    page: 1,
                    lastPage: 1,
                    from: 1,
                    to: 1,
                    maxPage: 1,
                    trashed: false,
                    status: 0,
                },
            };
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                if (from.name == "login") {
                    vm.$router.go();
                }
            });
        },

        mounted() {
            this.$store.dispatch("setStatus", null);
            this.dashboardCalculations();
        },

        methods: {
            showTrips(status){
                    
            this.$store.dispatch("setStatus", status);
            this.$router.push('/trips');
            },
            convertDateFormat(date) {
                if (!date) return "";
                return moment(date).format("DD-MM-yyyy hh:mm a");
            },
            search() {
                let vm = this;
                vm.meta.page = 1;
                vm.index();
            },
            dashboardCalculations() {
                let vm = this;
                let uri = { uri: "dashboardCalculations" };
                vm.$store
                    .dispatch("post", uri)
                    .then(function (response) {
                        vm.total_users = response.data.total_users;
                        (vm.total_trips = response.data.total_trips), (vm.trips_completed = response.data.trips_completed);
                        vm.trips_pending = response.data.trips_pending;
                        vm.index();
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },
            edit(trip) {
                this.$router.push("/trip/" + trip.trip_id + "/edit");
            },
            view(trip) {
                this.$router.push("/trip/" + trip.trip_id + "/view");
            },

            index() {
                let vm = this;
                vm.$store
                    .dispatch("post", { uri: "paginateTrips", data: vm.meta })
                    .then((response) => {
                        vm.trips = response.data.data;
                        vm.meta.totalRows = response.data.meta.total;
                        vm.meta.from = response.data.meta.from;
                        vm.meta.to = response.data.meta.to;
                        vm.meta.lastPage = response.data.meta.last_page;
                        vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                    })
                    .catch(function (error) {
                        vm.errors = error.response.data.errors;
                        vm.$store.dispatch("error", error.response.data.message);
                    });
            },
            onPageChange(page) {
                let vm = this;
                vm.meta.page = page;
                vm.index();
            },
            sort(field) {
                let vm = this;
                vm.meta.keyword = field;
                vm.meta.order_by = vm.meta.order_by == "asc" ? "desc" : "asc";
                vm.index();
            },
            onPerPageChange() {
                this.meta.page = 1;
                this.index();
            },
        },
    };
</script>
